import type { RouteRecordRaw } from 'vue-router';
import { Urls } from '@/config/Urls';
import { UserRoles } from '@/modules/admin/interfaces/UserRoles';

const ADMIN_OR_GATEKEEPER = [UserRoles.ADMIN, UserRoles.GATEKEEPER];

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: Urls.ADMINISTRATION,
    name: 'administration',
    redirect: Urls.ADMINISTRATION_USERS,
    component: () => import('./pages/AdministrationLayout.vue'),
    meta: { requiresAuth: true, roles: ADMIN_OR_GATEKEEPER },
    children: [
      {
        path: 'users',
        name: 'administrationUsers',
        component: () => import('./pages/Administration/Administration.vue'),
        meta: { requiresAuth: true, roles: ADMIN_OR_GATEKEEPER },
      },
      {
        path: 'users/add',
        name: 'administrationAddUser',
        component: () => import('./pages/Administration/AddNewUser.vue'),
        meta: { requiresAuth: true, roles: ADMIN_OR_GATEKEEPER },
      },
      {
        path: 'logs',
        name: 'administrationLogs',
        component: () => import('./pages/AuditLogs/AuditLogs.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: 'configuration',
        name: 'administrationConfiguration',
        component: () => import('./pages/Configuration/Configuration.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
    ]
  },
  // Judges list - accessible to Admin and Supervisor
  {
    path: Urls.JUDGES,
    name: 'judges',
    component: () => import('./pages/Judges/Judges.vue'),
    meta: { requiresAuth: true, requiresSupervisor: true },
  },
];